import { useLocation } from 'react-router-dom';
import { ApiConfig, StoreApiConfig } from '../config/apiConfig';

export const countryImageUrlByCode = (code: string) => {
  return `${ApiConfig.protocol}://${ApiConfig.host}/assets/images/countries/png/${code}.png`;
};

export const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

export const imageUrl = (imagePath: string) =>
  `${ApiConfig.protocol}://${ApiConfig.host}/storage/${imagePath}`;

export const publicImageUrl = (imagePath: string) =>
  `${ApiConfig.protocol}://${ApiConfig.host}/${imagePath}`;

export const storeImageUrl = (imagePath: string) =>
  `${StoreApiConfig.protocol}://${StoreApiConfig.host}//${StoreApiConfig.uriBasePath}/image/${imagePath}`;

export const storeWebsiteUrl = function (suffix?: string) {
  let route = suffix ? suffix : 'route=common/home';
  return `${StoreApiConfig.protocol}://${StoreApiConfig.host}${StoreApiConfig.pathPrefix}?${route}`;
};

export const youtubeImageUrl = (videoId: string): string => {
  return `${ApiConfig.protocol}://${ApiConfig.host}/youtube-image/${videoId}`;
};

export const downloadFile = async (fileUrl: string, fileName: string) => {
  try {
    const response = await fetch(fileUrl, { mode: 'cors' });
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = fileName || 'downloaded-file';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error('Download failed:', error);
  }
};
